import { render, staticRenderFns } from "./AwardsAndHonors.vue?vue&type=template&id=567f54c3&scoped=true&"
import script from "./AwardsAndHonors.vue?vue&type=script&lang=js&"
export * from "./AwardsAndHonors.vue?vue&type=script&lang=js&"
import style1 from "./AwardsAndHonors.vue?vue&type=style&index=1&id=567f54c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567f54c3",
  null
  
)

export default component.exports